import type { ArcadeScreen } from "../ScreenManager.js";
import type { MenuAction } from "../MenuInput.js";

/**
 * TITLE / attract — idle cabinet (menu-redesign-plan §3.2). Big HTML/CSS
 * wordmark (Orbitron 900 + neon glow, no image asset), "PRESS START" blink,
 * footer with version + sign-in status. ANY input → MAIN MENU.
 * (The M5 attract demo runs behind this screen later — nothing here blocks it.)
 */

export interface TitleScreenDeps {
  version: string;
  /** Footer status, re-read on every enter (e.g. "GUEST MODE" / "SIGNED IN — NAME"). */
  getAuthLine: () => string;
  /** Advance to MAIN MENU. Called at most once per enter. */
  onStart: () => void;
}

export class TitleScreen implements ArcadeScreen {
  private authEl: HTMLElement | null = null;
  private started = false;

  constructor(private readonly deps: TitleScreenDeps) {}

  mount(root: HTMLElement): void {
    root.innerHTML = `
      <div class="title-inner">
        <div class="title-word" role="heading" aria-level="1" aria-label="Bang Bop Cars">
          <span class="title-line1" aria-hidden="true">BANG&nbsp;BOP</span>
          <span class="title-line2" aria-hidden="true">CARS</span>
          <span class="title-underbar" aria-hidden="true"></span>
        </div>
        <div class="title-tag">MULTIPLAYER CAR COMBAT</div>
        <div class="title-press">PRESS START</div>
      </div>
      <div class="title-footer">
        <span class="title-version">v${this.deps.version}</span>
        <span class="title-auth"></span>
      </div>`;
    this.authEl = root.querySelector(".title-auth");
    root.addEventListener("pointerdown", () => this.start());
  }

  onEnter(): void {
    this.started = false;
    if (this.authEl) this.authEl.textContent = this.deps.getAuthLine();
  }

  onLeave(): void {
    /* nothing to tear down */
  }

  handleInput(_action: MenuAction): boolean {
    this.start();
    return true;
  }

  private start(): void {
    if (this.started) return;
    this.started = true;
    this.deps.onStart();
  }
}
